import React, { ReactNode } from "react";
import "../styles/contactus.scss";
export class ContactUs extends React.Component {
    render(): ReactNode {
        return (
            <section className="headerinfo bg">
                <div className="contactUs">
                    <div className="contactUs_title btn_title">联系我们</div>
                    <div className="contactUs_content">
                        <div className="listitem">参观咨询：</div>
                        <hr></hr>
                        <p>咨询电话：0512-53890911</p>
                        <p>服务时间08：00-20:00</p>

                        <div className="listitem"> 接待中小学生集体参观免票</div>
                        <hr></hr>
                        <p>学校凭介绍信须提前5天与我馆宣传部联系、登记，共同商定参观时间。如预约时超过我馆接待能力，再做商定。</p>
                        <p> 联系电话（传真）0512-53890911</p>
                        <div className="listitem"> 藏品征集：</div>
                        <hr></hr>
                        <p>藏品征集邮箱</p>
                        <div className="listitem">地址：</div>
                        <hr></hr>
                        <p>上海东路100号（西门）</p>
                        <p>邮编</p>
                        <div className="listitem">网站维护：</div>
                        <hr></hr>
                        <p>太仓博物馆 数字与信息部</p>
                        <p>传真：</p>
                        <p>电子邮件</p>
                    </div>
                </div>
            </section>
        )
    }

}